import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css"; 
import './scss/index.scss';
import './BtcRateContext';
import { BtcRateProvider } from './BtcRateContext';
import './i18n';
import ReactGA from 'react-ga';


// Inicializace Google Analytics
const trackingId = "G-5K1DB3CWVF"; // Zde vložte vaše měřicí ID
ReactGA.initialize(trackingId);

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <BtcRateProvider>
        <App />
      </BtcRateProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// react-snap: pokud má element prerendered obsah, použij hydraci
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
